const namespaced = true

const state = {
  content: true
}

const mutations = {
  SET_CONTENT(state, payload) {
    state.content = payload
  }
}

const actions = {
  showContent({ commit }) {
    commit('SET_CONTENT', true)
  },
  hideContent({ commit }) {
    commit('SET_CONTENT', false)
  }
}

const getters = {
  getContent: state => state.content
}

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
}
